import { computed } from '@ember/object';
// eslint-disable-next-line import/default
import FieldKit from 'field-kit';
import InputText from './input-text';
const DIGITS_PATTERN = /^\d*$/;
class NumberFormatter extends FieldKit.Formatter {
  format(value) {
    if (typeof value === 'number') {
      return value.toString();
    }
    if (typeof value === 'string') {
      const valueAsNumber = Number.parseInt(value, 10);
      if (!Number.isNaN(valueAsNumber)) {
        return valueAsNumber.toString();
      }
    }
    return '';
  }
  parse(string) {
    return string ? Number(string) : null;
  }
  isChangeValid(change, error) {
    if (DIGITS_PATTERN.test(change.inserted.text)) {
      return super.isChangeValid(change, error);
    } else {
      return false;
    }
  }
}

/**
 * This component renders a text input that only accepts numbers. It is an extension of
 * <Prism::InputText /> and supports all the same properties.
 *
 * @example
 * ```
 * <Prism::InputNumber
 *   @value={{this.nameOfValueProperty}}
 *   @inputId="my-id"
 *   @label="Number of dogs"
 *   @placeholder="Put number here"
 *   @onChange={{action (mut nameOfValueProperty))}}
 * />
 * ```
 *
 */
export default InputText.extend({
  /**
   * @override
   */
  inputType: 'tel',
  formatter: computed(function () {
    return new NumberFormatter();
  })
});